'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _defineProperty = _interopDefault(require('@babel/runtime/helpers/defineProperty'));
var constants = require('../constants.js');
var styledBreakpoint = require('./styledBreakpoint.js');
var React = _interopDefault(require('react'));
var CustomPropTypes = require('../CustomPropTypes.js');

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var gridColumnOffset = (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$columns = _ref.columns,
    columns = _ref$columns === void 0 ? constants.columns : _ref$columns,
    _ref$styledBreakpoint = _ref.styledBreakpointOptions,
    styledBreakpointOptions = _ref$styledBreakpoint === void 0 ? {
      suffix: '-column-offset'
    } : _ref$styledBreakpoint,
    _ref$defaultProps = _ref.defaultProps,
    defaultProps = _ref$defaultProps === void 0 ? {} : _ref$defaultProps;
  return function (component) {
    var _styledBreakpoint = styledBreakpoint.default(styledBreakpointOptions)(component),
      Component = _styledBreakpoint.component,
      propNames = _styledBreakpoint.propNames;
    var GridColumnOffset = function GridColumnOffset(props) {
      var newProps = propNames.reduce(function (allNewProps, propName) {
        var value = allNewProps[propName];
        if (typeof value !== 'number') return allNewProps;
        return _objectSpread(_objectSpread({}, allNewProps), {}, _defineProperty({}, propName, "\n            margin-left: ".concat(value === 0 ? 0 : value / columns * 100, "%;\n          ")));
      }, props);
      return /*#__PURE__*/React.createElement(Component, newProps);
    };
    GridColumnOffset.defaultProps = defaultProps;
    GridColumnOffset.propTypes = propNames.reduce(function (allPropTypes, propName) {
      return _objectSpread(_objectSpread({}, allPropTypes), {}, _defineProperty({}, propName, CustomPropTypes.default.integerRange(0, columns - 1)));
    }, {});
    return GridColumnOffset;
  };
});

exports.default = gridColumnOffset;
